import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import DataLakeOverview from "data-lake/data-lake-overview/DataLakeOverview";
import DataLakeJobs from "data-lake/components/DataLakeJobs";
import DataLakeRetrievableSizeChart from "data-lake/components/DataLakeRetrievableSizeChart";
import DataLakeJournalSection from "data-lake/components/DataLakeJournalSection";
import DataLakeVolumeSection from "data-lake/components/DataLakeVolumeSection";
import DataLakePageNavigation from "data-lake/components/DataLakePageNavigation";
import useDataLakeFSVolumeMetrics from "data-lake/hooks/useDataLakeFSVolumeMetrics";
import useActiveDataLakeBackendType from "data-lake/data-lake-backend-config/hooks/useActiveDataLakeBackendType";
import { FILESYSTEM_TYPE } from "archive/ArchiveStore";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useSendTelemetryOnMount from "logic/telemetry/useSendTelemetryOnMount";
import { DATA_LAKE_LICENSE_TITLE, DATA_LAKE_LICENSE_TEXT } from "data-lake/Constants";
import { Alert, Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import AppConfig from "util/AppConfig";
import DocsHelper from "util/DocsHelper";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const Divider = styled.hr(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.md};
  `
);
const VolumeBorderCol = styled(Col)(
  ({ theme }) => css`
    border-left: 1px solid ${theme.colors.gray[80]};
    padding-left: ${theme.spacings.lg};
  `
);
const DataLakesPage = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const sendTelemetry = useSendTelemetry("data-lake-overview");
  const { data: backendType, isSuccess: isBackendTypeLoaded } = useActiveDataLakeBackendType();
  const volume = useDataLakeFSVolumeMetrics();
  const isFsBackend = backendType === FILESYSTEM_TYPE;
  const showVolumeSection = isFsBackend && volume.hasData && !volume.isLoading;
  const showJournalSection = !AppConfig.isCloud();
  useSendTelemetryOnMount(
    sendTelemetry,
    TELEMETRY_EVENT_TYPE.DATALAKE.ACTIVE_BACKEND,
    { app_pathname: "data-lake", backend_type: isBackendTypeLoaded && backendType ? backendType : "none" },
    [isBackendTypeLoaded, backendType]
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("overview_page.title") }, /* @__PURE__ */ React.createElement(DataLakePageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("overview_page.title"),
      documentationLink: {
        title: t("overview_page.documentation_link"),
        path: DocsHelper.PAGES.DATA_LAKE
      }
    },
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("overview_page.intro_definition"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "overview_page.intro_backend", components: { bold: /* @__PURE__ */ React.createElement("strong", null) } }), /* @__PURE__ */ React.createElement("br", null), t("overview_page.intro_categorization"), /* @__PURE__ */ React.createElement("br", null), t("overview_page.intro_license"))
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.archive,
      title: t(DATA_LAKE_LICENSE_TITLE),
      text: t(DATA_LAKE_LICENSE_TEXT),
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(DataLakeJobs, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeRetrievableSizeChart, null), (showJournalSection || showVolumeSection) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(Row, null, showJournalSection && /* @__PURE__ */ React.createElement(Col, { md: showVolumeSection ? 6 : 12 }, /* @__PURE__ */ React.createElement(DataLakeJournalSection, null)), showVolumeSection && /* @__PURE__ */ React.createElement(VolumeBorderCol, { md: 6 }, /* @__PURE__ */ React.createElement(DataLakeVolumeSection, { volume })))))), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeOverview, null))));
};
export default DataLakesPage;
